import { EventStatusEnum, EventStatusTabKeysEnum } from 'src/shared/models/enums/eventStatus.enum';

export interface EventStatusTabItem {
  label: string;
  key: string;
  values: number[];
  description: string;
}

export const eventTabs: EventStatusTabItem[] = [
  {
    label: 'event:eventStatus.upcoming',
    key: EventStatusTabKeysEnum.Upcoming,
    values: [EventStatusEnum.Upcoming],
    description: '',
  },
  {
    label: 'event:eventStatus.completed',
    key: EventStatusTabKeysEnum.Completed,
    values: [EventStatusEnum.Completed],
    description: '',
  },
  // {
  //   label: 'event:eventStatus.canceled',
  //   key: EventStatusTabKeysEnum.Cancelled,
  //   values: [EventStatusEnum.Canceled],
  //   description: '',
  // },
];
